<template>
    <div
        :class="['tag', classObject]"
        @click="onClickHandler"
    >
        <div class="tag__title">{{ name }}</div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'

const emit = defineEmits(['change', 'clear'])
const props = defineProps({
    id: String,
    name: String,
    disabled: Boolean,
    selected: Boolean,
    interactive: {
        type: Boolean,
        default: true
    }
})

const isSelected = ref(false)

const classObject = computed(() => {
    return {
        'tag--selected': isSelected.value,
        'tag--disabled': props.disabled,
        'tag--no-interactive': !props.interactive
    }
})

const onClickHandler = () => {
    if (!props.disabled) {
        isSelected.value = !isSelected.value
        send()
    }
}

// const clear = () => {
//     isSelected.value = false

//     emit('clear', {
//         name: props.name,
//         value: isSelected.value,
//         id: props.id
//     })
// }

const send = () => {
    emit('change', {
        name: props.name,
        value: isSelected.value,
        id: props.id
    })
}

watch(props.selected, (newVal) => {
    isSelected.value = newVal
})

onMounted(() => {
    if (typeof props.selected !== 'undefined') {
        isSelected.value = props.selected
    }
})
</script>

<style lang="scss">
.tag {
    $parent: &;

    display: inline-flex;
    font-size: 1rem;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.16px;
    color: var(--color-link-default);
    background-color: transparent;
    border: 1px solid var(--color-link-default);
    border-radius: 20px;
    padding: 0.5rem 1rem;
    transition: color $transition, background-color $transition,
        border-color $transition;
    cursor: pointer;

    &:not(#{$parent}--selected) {
        &:hover {
            background-color: var(--color-link-hover);
            color: var(--color-white);
            border-color: var(--color-link-hover);
        }
    }

    &--disabled {
        background-color: var(--color-link-disabled);
        color: var(--color-white);
        border-color: var(--color-link-disabled);
        pointer-events: none;
    }

    &--selected {
        background-color: var(--color-link-active);
        color: var(--color-white);
        border-color: var(--color-link-active);
    }

    &--no-interactive {
        pointer-events: none;
    }
}
</style>
